import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconKeyboardArrowRightLine = ({
  width,
  height,
  fill = 'currentColor',
  ...props
}: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.946 12 8.873 7.927a.726.726 0 0 1-.212-.522.708.708 0 0 1 .212-.532.718.718 0 0 1 .527-.217c.206 0 .382.072.527.217l4.494 4.494a.831.831 0 0 1 .256.633.832.832 0 0 1-.256.633l-4.494 4.494a.726.726 0 0 1-.522.213.708.708 0 0 1-.532-.213.718.718 0 0 1-.217-.527c0-.206.072-.382.217-.527L12.946 12Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconKeyboardArrowRightLine;
